import { TextInputField } from "@surya-digital/leo-reactjs-material-ui";
import { Instance } from "mobx-state-tree";
import React from "react";
import { useTranslation } from "react-i18next";
import { BoundedNameModel } from "../../../models/BoundedNameModel";
import { getEmailTemplateValidationErrorMessage } from "../../../emailTemplates/utils/getEmailTemplateValidationErrorMessage";
import { observer } from "mobx-react";

interface SaveTemplateFormProps {
  templateName: Instance<typeof BoundedNameModel>;
  disableForm: boolean;
}

export const SaveTemplateForm: React.FC<SaveTemplateFormProps> = observer(
  ({ templateName, disableForm }) => {
    const { t } = useTranslation();

    const { name: templateNameValidationErrorMessage } =
      getEmailTemplateValidationErrorMessage(t, {
        name: templateName.validationError,
        content: undefined,
      });

    return (
      <TextInputField
        name="templateName"
        label={t("emailTemplates.titleLabel")}
        placeholder={t("emailTemplates.titlePlaceholder")}
        value={templateName.name}
        type="text"
        onTextChange={templateName.setName}
        disabled={disableForm}
        error={!!templateNameValidationErrorMessage}
        helperText={templateNameValidationErrorMessage}
      />
    );
  },
);
